import { API } from 'aws-amplify';
import { UpdateContactRequest } from '../data_types/update-contact-request';
import { auth, getAuthHeaders } from './auth';

const updateContact = async (contactId: string, request: UpdateContactRequest): Promise<void> => {
    const session = await auth.getSession();
    if (!session.authenticated) {
        throw new Error('Not authenticated');
    }

    return API.post('membership', `/contact/${contactId}`, {
        headers: getAuthHeaders(),
        body: {
            ...request,
        },
    });
};

export default updateContact;
